import React from "react"
import PageTransition from 'gatsby-plugin-page-transitions';
// import { Link } from "gatsby"
import Layout from "../components/layout"
import VideoCover from "../components/video-cover"
import Realisation from "../components/realisation"
import ToggleBox from "../components/toggle-box"
import DemandCallToAction from "../components/demand-call-to-action"
import SEO from "../components/seo"
// import helpers from "../scripts/helpers"
//PAGE COMPONNENTS
import GestionProjetArticle from "../components/article-gestion-projet"
import DevArticle from "../components/article-dev"
import InfraArticle from "../components/article-infra"
import Sponsores from "../components/sponsores"
  import WhoAreWe from "../components/who-are-we"

class Developpement extends React.Component {
  render = () => (
    
      <Layout>
        <SEO title="Développement et maintenance" keywords={[
          "it services for businesses","service business","it services solution","in service business","it company","services: processes and","marketing service","manage it service","business process outsourcing companies","it solutions","infrastructure and services","informatique consulting","conseil en informatique","entreprise conseil informatique","consultant en informatique","site conseil informatique","recrutement consultant informatique","recherche consultant informatique","consultant informatique emploi","service conseil informatique","consultant securité informatique","conseil marketing paris","offre consultant informatique","entreprise developpement informatique","entreprise développement informatique","externalisation informatique","cloud server","cloud service","cloud technology","cloud","cloud computing","le cloud computing","développement cloud","hybrid cloud","cloud security","cloud hosting","hébergement cloud","azure","datacenter","le cloud informatique","informatique cloud","cloud erp","migration cloud","cloud entreprise","data center","sécurité dans le cloud","sécurité du cloud","sécurité du cloud computing","formation cloud","applications","oracle cloud","cloud","cloud server","cloud service","cloud technology","azure","cloud computing","hybrid cloud","cloud security","public cloud","cloud storage","serveur cloud","le cloud computing","cloud stockage","serveur cloud privé","cloud entreprise","cloud privé entreprise","data center","développement cloud","migration cloud","cloud privé","logiciel cloud","hébergement cloud","solution stockage cloud","sécurité dans le cloud","cybersécurité","cyber sécurité","sécurité informatique","sécurité sur internet","securite informatique","sécurité web","formation cyber sécurité","sécurité it","formation cybersécurité","sécurité développement informatique","informatique sécurité","it security","information security","sécurité logicielle","securité informatique","la sécurité informatique","sécurité des systèmes","audit de sécurité","sécurité information","sécurité des données","sécurité données","securite web","la sécurité des réseaux","sécurité système informatique cours","sécurité ordinateur","digital","digital marketing","digital strategy","consultant digital","digital transformation"
        ]} />
        <main className="scroll-jacker">
          
          <VideoCover
              title="Développement et maintenance"
              videoUrl="/video/positiveemotiondev.mp4" 
          />

          <main className="manifest">

            <section className="manifest__section manifest__section--services">
              <h2 className="article__heading p-0">GESTION DE PROJETS</h2>
              <header className="manifest__services-header manifest__services-header--toggled">
              </header>
              <GestionProjetArticle />
            </section>

            <section className="manifest__section manifest__section--services">
              <h2 className="article__heading p-0">DÉVELOPPEMENT </h2>
              <header className="manifest__services-header manifest__services-header--toggled"></header>
              <DevArticle />
            </section>

            <section className="manifest__section manifest__section--services">
              <h2 className="article__heading p-0">SERVER ADMINISTRATION</h2>
              <header className="manifest__services-header manifest__services-header--toggled"></header>
              <InfraArticle />
            </section>

          </main>

        </main>
        <Sponsores />
        <WhoAreWe />
      </Layout>
    
  )

  componentDidMount = () => { 
    // helpers.initCallToActionBanner()
  }


}

export default Developpement
